<template>
  <DefaultPage id="about">
    <div class="about">
      <div class="hero">
        <HeroTexture class="hero-texture" />
        <HeroTextureTwo class="hero-texture-two" />
        <div class="hero-flex-wrap">
          <div class="grid-x grid-margin-x align-middle">
            <div class="cell large-9 xlarge-7 xxlarge-6">
              <div class="hero__call">
                <h1
                  class="hero__headline"
                  data-aos="fade-right"
                  data-aos-duration="1000"
                >
                  <span class="have-heart-alt">A</span>bout
                </h1>
                <div
                  class="hero__call__content"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <p>
                    As we celebrate our 50th year as a mutual company, we look to the future with our new board leaders and a continued, unwavering commitment to supporting physicians.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="about__content">
        <div class="about__section">
          <img
            class="about__texture"
            src="@/assets/texture-3.png"
          />
          <div class="about__mission-vision-wrapper">
            <div class="about__mission-vision">
              <div
                class="our-section our-section--mission"
                data-aos="fade-right"
                data-aos-duration="400"
                data-aos-offset="400"
              >
                <div class="our-section__content">
                  <h5>Our Mission</h5>
                  <p>Protect, support, and advocate for physicians and other healthcare providers.</p>
                </div>
              </div>
              <div
                class="our-section our-section--vision"
                data-aos="fade-left"
                data-aos-duration="400"
                data-aos-offset="400"
              >
                <div class="our-section__content">
                  <h5>Our Vision</h5>
                  <p>To be the premier provider of medical professional liability insurance, education, and support in the markets we serve.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="about__section">
          <div
            class="our-section our-section--values"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-offset="400"
            data-aos-id="values-widget"
          >
            <ValuesMasterDetail/>
          </div>
        </div>
      </div>
      <TheSubFooter />
    </div>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import TheSubFooter from '@/components/footer/TheSubFooter';
import ValuesMasterDetail from '@/components/master-detail/ValuesMasterDetail';
import HeroTexture from '@/assets/texture-about-hero.svg';
import HeroTextureTwo from '@/assets/texture-about-hero-2.svg';

export default {
  name: 'About',
  components: {
    ValuesMasterDetail,
    DefaultPage,
    TheSubFooter,
    HeroTexture,
    HeroTextureTwo,
  }
};
</script>
